import React from 'react'
import ReactDOM from 'react-dom'
import { getDefaultLoginURL, getDefaultLogoutURL } from './authUrl'

import App from '../App'
import { CSRHeader } from '../components/CSRHeader/CSRHeader'

import i18n from '../i18n/config'
import { setLangAttribute } from '../helper/lang'
import { LanguagePreference } from 'models/LanguagePreference'
import store from 'redux/config'

const renderHeader = (rootNode: Element | null, LDProvider: React.FC) => {
  const lang = (setLangAttribute(rootNode?.getAttribute('lang')) ?? 'en') as LanguagePreference
  i18n.changeLanguage(lang)

  const languageToggleLink = rootNode?.getAttribute('lang-toggle-link') || ''
  const headerType = rootNode?.getAttribute('header-type') || ''

  let headerComponent

  if (headerType.toLowerCase() === 'csr') {
    const beneficiary = rootNode?.getAttribute('beneficiary') || '{}'
    headerComponent = <CSRHeader languageToggleLink={languageToggleLink} beneficiary={beneficiary} />
  } else {
    const defaultLoginURL = getDefaultLoginURL(lang)
    const defaultLogoutURL = getDefaultLogoutURL(lang)

    const loginUrl = rootNode?.getAttribute('login-url') || defaultLoginURL
    const logoutUrl = rootNode?.getAttribute('logout-url') || defaultLogoutURL
    const enableLiveChat = rootNode?.getAttribute('enable-live-chat') === 'true'

    let enableMessageCenter
    if (process.env.REACT_APP_ENABLE_MESSAGE_CENTER === 'true') {
      enableMessageCenter = rootNode?.getAttribute('enable-message-center') !== 'false'
    } else {
      enableMessageCenter = rootNode?.getAttribute('enable-message-center') === 'true'
    }

    const disableLogin = (rootNode?.getAttribute('disable-login') === 'true')
    const liveChatViewpage = (rootNode?.getAttribute('live-chat-viewpage') || undefined)
    const activeNavSection = (rootNode?.getAttribute('active-nav-section') || undefined)

    const enableTimeout = (rootNode?.getAttribute('enable-timeout') === 'true')

    headerComponent = (
      <LDProvider>
        <App
          store={store}
          currentLangProps={lang}
          activeNavSection={activeNavSection}
          disableLogin={disableLogin}
          languageToggleLink={languageToggleLink}
          loginUrl={loginUrl!}
          logoutUrl={logoutUrl!}
          enableLiveChat={enableLiveChat}
          enableMessageCenter={enableMessageCenter}
          liveChatViewpage={liveChatViewpage}
          enableTimeout={enableTimeout}
        />
      </LDProvider>
    )
  }

  ReactDOM.render(
    <React.StrictMode>
      <div id='ch-root' style={{ visibility: 'hidden', height: '92px', maxHeight: '92px' }}>{headerComponent}</div>
    </React.StrictMode>,
    rootNode
  )
}

export default renderHeader
